import gql from 'graphql-tag'

export const NOTI_FLASH = gql`
  mutation notifyFlashExpress($input: NotifyFlashExpressInput!) {
    notifyFlashExpress(input: $input) {
      response
      errors
    }
  }
`

export const CANCEL_NOTI_FLASH = gql`
  mutation cancelNotifyFlashExpress($input: CancelNotifyFlashExpressInput!) {
    cancelNotifyFlashExpress(input: $input) {
      response
      errors
    }
  }
`

export default {
  NOTI_FLASH,
  CANCEL_NOTI_FLASH
}
